import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { btnS } from '../../../../shared/globalStyling/style';
import { Input, Space } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import GlobalButton from '../../../../shared/globalStyling/Button';

const PublisherDomainTableSearch = ({ location, history }) => {
  const params = new URLSearchParams(location.search);
  const tagIdSearch = params.get('publisherTagId');
  const nameSearch = params.get('publisherName');

  const [tagIdSearchValues, setTagIdSearchValue] = useState();
  const [nameSearchValues, setNameSearchValue] = useState();

  return (
    <Space className="ant-space-xs-vertical ant-space-md-horizontal" size={'small'}>
      <Input
        placeholder={'Search By Tag ID'}
        value={tagIdSearchValues}
        onChange={(e) => {
          const value = e.target.value;
          setTagIdSearchValue(value);

          if (value === '') {
            params.delete('publisherTagId');
            history.push({
              pathname: location.pathname,
              search: `?${params.toString()}`,
            });
          }
        }}
        onPressEnter={(val) => {
          const searchValue = val.target.value;
          if (tagIdSearch) params.delete('publisherTagId');

          if (searchValue !== '') {
            params.append('publisherTagId', searchValue);
          } else {
            params.delete('publisherTagId');
          }

          history.push({
            pathname: location.pathname,
            search: `?${params.toString()}`,
          });
        }}
        defaultValue={tagIdSearch}
        allowClear
      />
      <Input.Search
        placeholder={'Search By Name'}
        value={nameSearchValues}
        onChange={(e) => setNameSearchValue(e.target.value)}
        onSearch={(searchValue) => {
          if (nameSearch) {
            params.delete('publisherName');
          }

          if (searchValue !== '') {
            params.append('publisherName', searchValue);
          } else {
            params.delete('publisherName');
          }

          history.push({
            pathname: location.pathname,
            search: `?${params.toString()}`,
          });
        }}
        defaultValue={nameSearch}
        allowClear
      />

      <GlobalButton
        shape="round"
        style={btnS}
        type={'default'}
        onClick={() => {
          if (tagIdSearch) params.delete('publisherTagId');
          if (nameSearch) params.delete('publisherName');

          setNameSearchValue();
          setTagIdSearchValue();
          history.push({
            pathname: location.pathname,
            search: `?${params.toString()}`,
          });
        }}
        disabled={!tagIdSearch && !nameSearch}
        icon={<CloseOutlined />}
      >
        Clear
      </GlobalButton>
    </Space>
  );
};

export default withRouter(PublisherDomainTableSearch);
